import {Fragment, useEffect, useState} from "react";
import {FormControl, FormLabel, Grid, MenuItem, Select, TextField} from "@mui/material";
import {getCountryCode} from "../../Utils/Helper";

export const WordPressQuoteFTL = ({cbHandleShippingDetails, validatedResult, lng}) => {

    const [FTlDetail, setFTLDetail] = useState({
        quantity: "1",
        transitCargoType: "Not-Bonded",
        totalWeight: "Less than 20,000 lbs",
        equipment: "Dry Van"
    });

    const handleTransitCargoType = event => {
        const {value} = event.target;
        setFTLDetail(prevState => ({
            ...prevState,
            transitCargoType: value
        }))
    }

    const handleTotalWeight = event => {
        const {value} = event.target;
        setFTLDetail(prevState => ({
            ...prevState,
            totalWeight: value
        }))
    }

    const handleEquipment = event => {
        const {value} = event.target;
        setFTLDetail(prevState => ({
            ...prevState,
            equipment: value
        }))
    }

    useEffect(() => {
        cbHandleShippingDetails(FTlDetail);
    }, [FTlDetail]);

    return (
        <Fragment>
            <Grid size={{xs: 12, md: 4}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '中转货物类型' : "Transit Cargo Type"}
                    </FormLabel>
                    <Select
                        sx={{
                            '& .MuiSelect-select': {
                                fontSize: '14px' // Set your desired font size here
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '5px 14px', // Removes inner padding
                                // height: '33px'
                            },
                        }}
                        value={FTlDetail?.transitCargoType}
                        size='small'
                        onChange={handleTransitCargoType}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 48 * 4.5 + 8,
                                    // width: 250,
                                },
                            },
                        }}
                    >
                        <MenuItem value={'Bonded'}>
                            Bonded
                        </MenuItem>
                        <MenuItem value={'Not-Bonded'}>
                            Not Bonded
                        </MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 4}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '总重' : "Total Weight"}
                    </FormLabel>
                    <Select
                        sx={{
                            '& .MuiSelect-select': {
                                fontSize: '14px' // Set your desired font size here
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '5px 14px', // Removes inner padding
                                // height: '33px'
                            },
                        }}
                        value={FTlDetail?.totalWeight}
                        size='small'
                        onChange={handleTotalWeight}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 48 * 4.5 + 8,
                                    // width: 250,
                                },
                            },
                        }}
                    >
                        <MenuItem value={'Less than 20,000 lbs'}>
                            Less than 20,000 lbs
                        </MenuItem>
                        <MenuItem value={'20,000 – 25,000 lbs'}>
                            20,000 – 25,000 lbs
                        </MenuItem>
                        <MenuItem value={'25,000 – 30,000 lbs'}>
                            25,000 – 30,000 lbs
                        </MenuItem>
                        <MenuItem value={'30,000 – 35,000 lbs'}>
                            30,000 – 35,000 lbs
                        </MenuItem>
                        <MenuItem value={'Over 35,000 lbs'}>
                            Over 35,000 lbs
                        </MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 4}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '设备' : "Equipment"}
                    </FormLabel>
                    <Select
                        sx={{
                            '& .MuiSelect-select': {
                                fontSize: '14px' // Set your desired font size here
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '5px 14px', // Removes inner padding
                                // height: '33px'
                            },
                        }}
                        value={FTlDetail?.equipment}
                        size='small'
                        onChange={handleEquipment}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 48 * 4.5 + 8,
                                    // width: 250,
                                },
                            },
                        }}
                    >
                        <MenuItem value={'Dry Van'}>
                            Dry Van
                        </MenuItem>
                        <MenuItem value={'Temperature Controlled'}>
                            Temperature Controlled
                        </MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Fragment>
    )
}